@if (this.isEditing) {
<kendo-dialog title="Kop geschiedenis" width="1200px" maxHeight="80vh" (close)="this.isEditing = false">

    <div class="lists-wrapper">
        <kop-history-list #leftList (onHistorySelected)="this.left = $event" [selectedHistory]="this.left"></kop-history-list>
        <kop-history-list #rightList (onHistorySelected)="this.right = $event"[selectedHistory]="this.right"></kop-history-list>
    </div>
    <div class="button-wrapper">
        <div class="left-button-wrapper">
            <button kendoButton (click)="this.restoreHistory(this.left?.id)" themeColor="primary" [disabled]="this.left == undefined || this.left.id == undefined">
                {{'Herstellen' | translate: 'Herstellen'}}
            </button>
            <button kendoButton (click)="this.editComment(this.left)" themeColor="primary" [disabled]="this.left == undefined || this.left.id == undefined">
                {{'Edit Comment' | translate: 'Edit Comment'}}
            </button>

        </div>

        <button kendoButton (click)="this.compareHistories()" themeColor="primary" [disabled]="this.right == undefined || this.left == undefined || this.right.id == this.left.id">
            {{'Vergelijk' | translate: 'Vergelijk'}}
        </button>
    </div>
    @if (this.jsBridgeService.isDev()) {
        <translation-editor />
    }

    <kendo-dialog-actions>
        <div class="button-bar">
            <button kendoButton (click)="this.isEditing = false" themeColor="primary">
                Close
            </button>

        </div>
    </kendo-dialog-actions>
</kendo-dialog>
}
<xmlcompare #xmlCompare></xmlcompare>